const FINANCE_LABEL = 'finance';

function isFinanceEnvEnabled(value?: string): boolean {
	if (!value) return false;

	const normalized = value.trim().toLowerCase();
	if (normalized.startsWith('app_next_')) return false;

	return normalized === '1' || normalized === 'true' || normalized === 'yes';
}

function getHostname(value: string): string {
	try {
		if (/^[a-z]+:\/\//i.test(value)) {
			return new URL(value).hostname;
		}
	} catch {
		// ignore invalid URL and fall back to raw host parsing
	}

	return value.split('/')[0].split(':')[0];
}

/** `finance.stg01…` (subdomain) или `*.finance` (TLD). */
function hasHostLabel(hostOrUrl: string | undefined, label: string): boolean {
	if (!hostOrUrl) return false;

	return getHostname(hostOrUrl)
		.split('.')
		.some((part) => part.toLowerCase() === label);
}

/**
 * Публичный ЛК на TLD `.finance`: `lk.rocketwork.finance`.
 * Метка `finance` здесь только зона, не продукт finance (`finance.stg…`, `app.rocketwork.finance`).
 */
export function isRegularLkHost(hostOrUrl?: string): boolean {
	const host = hostOrUrl ?? (typeof window !== 'undefined' ? window.location.hostname : undefined);

	if (!host) return false;

	const parts = getHostname(host)
		.split('.')
		.filter(Boolean)
		.map((part) => part.toLowerCase());

	if (parts.length < 3 || parts[0] !== 'lk') return false;

	const rest = parts.slice(1);

	return rest[rest.length - 1] === FINANCE_LABEL && !rest.slice(0, -1).includes(FINANCE_LABEL);
}

/**
 * Finance domain flag: hostname contains `finance` label
 * (e.g. finance.stg01.rwork.pro, app.rocketwork.finance),
 * or `VITE_IS_FINANCE` is explicitly enabled.
 */
export function isFinance(hostOrUrl?: string): boolean {
	if (isFinanceEnvEnabled(import.meta.env.VITE_IS_FINANCE)) return true;

	if (hasHostLabel(hostOrUrl, FINANCE_LABEL)) return true;

	if (typeof window !== 'undefined' && hasHostLabel(window.location.hostname, FINANCE_LABEL)) return true;

	return false;
}

/** PL: hostname содержит метку `pl` (pl.rocketwork…). */
export function isPl(hostOrUrl?: string): boolean {
	if (hasHostLabel(hostOrUrl, 'pl')) return true;

	if (typeof window !== 'undefined' && hasHostLabel(window.location.hostname, 'pl')) return true;

	return false;
}

/** YPLA: hostname содержит `ypla` (как finance по домену). */
export function isYpla(hostOrUrl?: string): boolean {
	if (hasHostLabel(hostOrUrl, 'ypla')) return true;

	if (typeof window !== 'undefined' && hasHostLabel(window.location.hostname, 'ypla')) return true;

	return false;
}
